var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var fieldnetTree = require('../../network/components/fieldnetTree');
var formGroup = require('../../components/formGroup');

var variable = Object.create(Model);

variable.name = 'Variable';
variable['@class'] = 'Variable';
variable.url = 'variable';

variable.fields = {
  out: {
    validators : {
      presence: true
    }
  },
  index: {
    default: null
  },
  in: {
    validators: {
      presence: true
    }
  },
  name: {
    default: null,
    validators : {
      presence : true,
      length: {minimum: 3, maximum: 128, default: ''}, 
    }
  },
  unit: {
    default: null,
    validators: {
      unit: {}
    }
  },
  unitConversion: {
    default: null,
    validators: {
      unit: {}
    }
  }
};  

variable.view = function (ctrl) {
  return m('form', {role:'form'}, [
    variable.errorView(),
    m(formGroup, [
      m('name', {for:'dashboard-name-input'}, 'Name'),
      m('input.form-control', {
        id:'dashboard-name-input', 
        type:'text', 
        onchange: function(ev){variable.form.name(ev.target.value)},
        value: variable.form.name(),
      })
    ]),
    m(fieldnetTree, {selectedPoint: variable.form.in}),
  ]);
};

module.exports = variable;
